module.exports = __webpack_public_path__ + "img/O2O-pic1-04.526ef5cb.png";